<template>
  <b-container
    tag="section"
    class="dashboard notifications details">
    <b-row>
      <b-col md="12">
        <router-link
          :to="{ name: 'SentNotifications' }"
          tag="div"
          class="back-to-list">
          <icon
            name="angle-left"
            width="14"
            height="14"/> Back to Notifications
        </router-link>
      </b-col>
      <b-col md="12">
        <h2 class="dashboard__title">
          Campaign details
        </h2>
      </b-col>
      <b-col md="3">
        <b-card
          no-body>
          <template v-slot:header>
            <h4 class="mb-0">Stats</h4>
          </template>
          <b-list-group
            v-if="campaignDetailsResDataLoaded"
            flush>
            <b-list-group-item>
              <p class="text-secondary">
                <icon name="paper-plane"/>{{ sent }} sent
              </p>
            </b-list-group-item>
            <b-list-group-item>
              <p class="text-info">
                <b-icon-flag-fill class="mr-2"/>{{ delivered }} delivered
              </p>
            </b-list-group-item>
            <b-list-group-item>
              <p class="text-success">
                <b-icon-eye class="mr-2"/>{{ campaignDetailsResData.bulk_res_data.read }} read
              </p>
            </b-list-group-item>
            <b-list-group-item>
              <p class="text-danger">
                <b-icon-alert-circle class="mr-2"/>{{ campaignDetailsResData.bulk_res_data.failed }} failed
              </p>
            </b-list-group-item>
          </b-list-group>
          <div
            v-else
            class="loader-20 mt-3 mb-3">
            <div class="loading-circle"/>
          </div>
        </b-card>
      </b-col>
      <b-col md="9">
        <b-table
          :fields="fields"
          :items="campaignDetails.data"
          show-empty
          responsive
          class="merchant-dashboard__table scroll-area-horizontal"
          tbody-tr-class="show-hand"
          details-td-class="campaign-details"
          @row-clicked="showNotifcationDetails">

          <!-- Name column -->
          <template v-slot:cell(name)="data">
            <span v-if="data.item.phone">{{ data.item.name }}</span>
            <span v-else>Campaign</span>
          </template>

          <!-- Phone column -->
          <template v-slot:cell(phone)="data">
            <div v-if="data.item.phone">{{ data.item.phone }}</div>
            <span
              v-else
              class="tag-item">
              {{ data.item.bulk_res_data.all }} numbers</span>
          </template>

          <!-- Status column -->
          <template v-slot:cell(status)="data">
            <span
              :id="`popover-details-${data.item.id}`"
              :class="setStatusClass(data.item.status)"
              class="tag-item">
              {{ data.item.status }}</span>
          </template>

          <!-- Actions column -->
          <template v-slot:cell(actions)="row">
            <b-dropdown
              right
              no-caret
              class="actions">
              <!-- button -->
              <template v-slot:button-content>
                <icon name="ellipsis-h"/>
              </template>
              <!-- Items -->
              <b-dropdown-item>
                <router-link
                  :to="{ name: 'ContactProfile', params: { contact_id: row.item.id } }"
                  tag="span">
                  Open Contact
                </router-link>
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <!-- Details section for progress or message content -->
          <template v-slot:row-details="">
            <div>
              <span>Message: </span>
              <p>
                {{ campaignDetailsResData.template_text }}
              </p>
            </div>
          </template>

          <!-- No data content -->
          <template v-slot:empty="">
            <div
              v-if="!campaignDetails.length && campaignDetailsLoaded"
              slot="empty"
              class="no-data text-center">
              <img
                src="~@/assets/img/no-data.svg"
                alt="No Data">
              <!--eslint-disable vue/no-v-html-->
              <span class="d-block mt-2">
                No data
              </span>
            </div>
            <div
              v-if="!campaignDetails.length && !campaignDetailsLoaded"
              slot="empty"
              class="loader">
              <div class="loading-circle"/>
            </div>
          </template>
        </b-table>

        <div class="paging mb-5 clearfix">
          <p class="float-left pages">{{ campaignDetails.meta.current_page }} of {{ campaignDetails.meta.last_page }}</p>
          <button
            :disabled="page === campaignDetails.meta.last_page"
            class="btn btn-default btn-paging float-right"
            @click="nextPage">Next</button>
          <button
            :disabled="page === 1"
            class="btn btn-default btn-paging float-right"
            @click="previousPage">Back</button>
          <b-input
            v-model="campaignDetails.meta.current_page"
            :disabled="campaignDetails.meta.last_page === 1"
            type="number"
            min="1"
            :max="campaignDetails.meta.last_page"
            class="page-input"
            placeholder="1"
            @change="changePage"/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<style lang="scss">
.dashboard.notifications.details .dashboard__title {
  margin-top: 0;
}

.campaign-details {
  background: $lightGray;
}

.card {
  margin-bottom: 20px;

  .fa-icon {
    margin-right: 8px;
    height: 11px;
  }
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CampaignDetails',
  components: {
  },
  data() {
    return {
      fields: [
        'name',
        {
          key: 'phone',
          label: 'Phone Number',
        },
        'status',
        {
          key: 'actions',
          class: 'text-right',
        },
      ],
      page: 1,
      limit: 10,
    };
  },
  computed: {
    ...mapGetters({
      campaignDetails: 'notification/campaignDetails',
      campaignDetailsLoaded: 'notification/campaignDetailsLoaded',
      campaignDetailsResData: 'notification/campaignDetailsResData',
      campaignDetailsResDataLoaded: 'notification/campaignDetailsResDataLoaded',
    }),
    sent() {
      return this.campaignDetailsResData.bulk_res_data.sent + this.campaignDetailsResData.bulk_res_data.delivered + this.campaignDetailsResData.bulk_res_data.read + this.campaignDetailsResData.bulk_res_data.failed;
    },
    delivered() {
      return this.campaignDetailsResData.bulk_res_data.delivered + this.campaignDetailsResData.bulk_res_data.read;
    },
  },
  watch: {

  },
  mounted() {
    this.getCampaignDetailsResData(this.$route.params);
    // retrive the paginated details for campaign
    this.loadCampaignDetails();
  },
  beforeDestroy() {
    this.resetCampaignDetails();
  },
  methods: {
    ...mapActions({
      getCampaignDetails: 'notification/getCampaignDetails',
      getCampaignDetailsResData: 'notification/getCampaignDetailsResData',
      resetCampaignDetails: 'notification/resetCampaignDetails',
    }),
    loadCampaignDetails() {
      this.getCampaignDetails({
        merchant_id: this.$route.params.merchant_id,
        campaign_id: this.$route.params.campaign_id,
        data: {
          limit: this.limit,
          page: this.page,
        },
      });
    },
    setStatusClass(status) {
      return {
        success: status === 'read',
        secondary: status === 'delivered',
        danger: status === 'failed',
      };
    },
    showNotifcationDetails(row, index) {
      // eslint-disable-next-line no-underscore-dangle
      this.campaignDetails.data[index]._showDetails = !this.campaignDetails.data[index]._showDetails;
    },
    nextPage() {
      if (this.page >= this.campaignDetails.meta.last_page) {
        return;
      }
      this.page += 1;
      this.loadCampaignDetails();
    },
    previousPage() {
      if (this.page === 1) {
        return;
      }
      this.page -= 1;
      this.loadCampaignDetails();
    },
    changePage(page) {
      page = parseInt(page, 10);
      if (page > this.campaignDetails.meta.last_page) {
        page = this.campaignDetails.meta.last_page;
      }
      if (!page || page < 1) {
        page = 1;
      }
      this.page = page;
      this.loadCampaignDetails();
    },
  },
};
</script>
